module.exports = __webpack_public_path__ + "images/help-videos-preview-todos-57f1dfc868b5d3c22fbce6d1bd8cefba.png";